module.exports = __webpack_public_path__ + "static/media/file_type_other_error_icon.79a7b5f1.svg";